module.exports = __webpack_public_path__ + "img/glm_gbt41_2000.prt.f89ca058.jpg";